"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCardExpirationMonths = exports.useCardExpirationYears = exports.useCardExpirationValues = void 0;
/*
Copyright (C) 2009 - 2021 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
const react_1 = require("react");
const payment_js_1 = require("@broadleaf/payment-js");
const useCardExpirationValues = () => {
    return (0, react_1.useMemo)(() => (0, payment_js_1.getCardExpirationValues)(), []);
};
exports.useCardExpirationValues = useCardExpirationValues;
const useCardExpirationYears = () => {
    return (0, react_1.useMemo)(() => (0, payment_js_1.getCardExpirationYears)(), []);
};
exports.useCardExpirationYears = useCardExpirationYears;
const useCardExpirationMonths = () => {
    return (0, react_1.useMemo)(() => (0, payment_js_1.getCardExpirationMonths)(), []);
};
exports.useCardExpirationMonths = useCardExpirationMonths;
//# sourceMappingURL=use-card-expiration-values.js.map